module.exports = __webpack_public_path__ + "static/media/T13 - Durini.f123de9e.jpg";